export const NAME = 'location-form-modules';
